import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { Observable, of } from 'rxjs';

import { SessionService } from 'src/app/services/storage/session.service';
import { ToastService } from 'src/app/services/toast.service';

import { BasePaths, AgentPaths } from 'src/app/constants/routes';
import { ToastType } from 'src/app/constants/toast-type';

@Injectable()
export class MemberSessionGuard implements CanActivate {
    constructor(
        private sessionService: SessionService,
        private toastService: ToastService,
        private router: Router,
    ) {
    }

    public canActivate(): Observable<boolean> {
        if (!this.sessionService.session.member && this.router.url != BasePaths.VersionError) {
            if (this.sessionService.session.agent) {
                this.toastService.buildToastMessage(ToastType.warning, 'Member Access Denied', 'Member data not found! Please reselect/select member for access.');
                this.router.navigateByUrl(AgentPaths.CounselorMemberLookup);
            } else {
                this.toastService.buildToastMessage(ToastType.warning, 'Access Denied', 'Please log in again to access account!');
                this.router.navigateByUrl(BasePaths.Members);
            }
        }

        return of(this.sessionService.session.isLoggedIn);
    }
}